import React from 'react';
import FgCompanyLogo from './FgCompanyLogo';
import DefaultLogo from './DefaultLogo';

export default class ClientLogo extends React.Component {
    static propTypes = {
        client: React.PropTypes.shape({
            id: React.PropTypes.string,
        }).isRequired
    };
    render() {
        var {client} = this.props;

        return client.fergusId
            ? <FgCompanyLogo fergusId={client.fergusId} />
            : <DefaultLogo />;
    }
}


// WEBPACK FOOTER //
// ./app/components/clients/ClientLogo.js